import ValidateInspectionPage from './ValidateInspectionPage';

export default ValidateInspectionPage;